import { CellPlugin } from '@react-page/editor';
import CarbonCountyResults, {
    WEB_ID_LABEL, NAME_LABEL, ADDRESS_LABEL, ACCOUNT_ID_LABEL, AMOUNT_DUE_LABEL, TOTAL_AMOUNT_DUE_LABEL, PAYMENT_OPTIONS_LABEL,
    HEADER_BACKGROUND_COLOR, HEADER_PADDING, MARGIN, PADDING, OVERLAY_TEXT, OVERLAY_BACKGROUND, OVERLAY_TEXT_COLOR, OVERLAY_ICON_COLOR
} from './components/CarbonCountyResults';

type Data = {
    title: string,
    webId: string,
    name: string,
    address: string,
    accountId: string,
    amountDue: string,
    totalAmountDue: string,
    paymentOptions: string,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    headerBackgroundColor: string,
    headerPadding: string,
    margin: string,
    padding: string,
}

const CarbonCountyResultsPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <CarbonCountyResults
            webIdLabel={data.webId}
            nameLabel={data.name}
            addressLabel={data.address}
            accountIdLabel={data.accountId}
            amountDueLabel={data.amountDue}
            totalAmountDueLabel={data.totalAmountDue}
            paymentOptionsLabel={data.paymentOptions}
            overlayText={data.overlayText}
            overlayBackground={data.overlayBackground}
            overlayTextColor={data.overlayTextColor}
            overlayIconColor={data.overlayIconColor}
            margin={data.margin}
            padding={data.padding}
            headerBackgroundColor={data.headerBackgroundColor}
            headerPadding={data.headerPadding}
        />
    ),
    id: 'carbonCountyResultsPlugin',
    title: 'Carbon County Search Results',
    description: 'Carbon County Table Results',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        webId: {
                            type: 'string',
                            default: WEB_ID_LABEL,
                        },
                        name: {
                            type: 'string',
                            default: NAME_LABEL,
                        },
                        address: {
                            type: 'string',
                            default: ADDRESS_LABEL,
                        },
                        accountId: {
                            type: 'string',
                            default: ACCOUNT_ID_LABEL,
                        },
                        amountDue: {
                            type: 'string',
                            default: AMOUNT_DUE_LABEL,
                        },
                        totalAmountDue: {
                            type: 'string',
                            default: TOTAL_AMOUNT_DUE_LABEL,
                        },
                        paymentOptions: {
                            type: 'string',
                            default: PAYMENT_OPTIONS_LABEL,
                        },
                        overlayText:{
                            type: 'string',
                            default: OVERLAY_TEXT
                        },
                        overlayBackground:{
                            type:'string',
                            default: OVERLAY_BACKGROUND
                        },
                        overlayTextColor:{
                            type:'string',
                            default: OVERLAY_TEXT_COLOR
                        },
                        overlayIconColor:{
                            type:'string',
                            default: OVERLAY_ICON_COLOR
                        }
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        headerBackgroundColor: {
                            type: 'string',
                            default: HEADER_BACKGROUND_COLOR,
                        },
                        headerPadding: {
                            type: 'string',
                            default: HEADER_PADDING,
                        }
                    },
                    required: [],
                },
            },
        },
    ],
};

export default CarbonCountyResultsPlugin;